import { ILibraryGroup } from '../libraryGroups.types'
import eventBus from '../../../services/eventBus'
import { ILibraryDocument } from '../libraryDocuments.types'

const createdGroup = (group: ILibraryGroup) => {
  eventBus.pub('libraryGroup.created', group)
}

const updatedGroup = (group: ILibraryGroup) => {
  eventBus.pub('libraryGroup.updated', group)
}

const deletedGroup = (id: ILibraryGroup['id']) => {
  eventBus.pub('libraryGroup.deleted', id)
}

const createdDocument = (document: ILibraryDocument) => {
  eventBus.pub('libraryDocument.created', document)
}

const updatedDocument = (document: ILibraryDocument) => {
  eventBus.pub('libraryDocument.updated', document)
}

const deletedDocument = (id: ILibraryDocument['id']) => {
  eventBus.pub('libraryDocument.deleted', id)
}

const libraryEvents = { createdGroup, updatedGroup, deletedGroup, createdDocument, updatedDocument, deletedDocument }

export default libraryEvents
